export default __webpack_public_path__ + "static/0060-bb65c87b92ee02b31c4ea8673941cf31.png";